import React, { useMemo } from 'react'
import { Grid } from '@mui/material'
import JobTextField from 'components/Drawers/JobDrawer/JobTextField'
import JobChipField from 'components/Drawers/JobDrawer/JobChipField'
import { countryOptions, stateOptions, areaOptions, AREA_ICONS } from 'components/Drawers/JobDrawer/constants'

const LocationSection = ({ values, setState, showError, setJobAlertData, allowedCountries }) => {
  const isUnitedStates = values.country === 'UnitedStates'

  const filteredCountryOptions = useMemo(() => {
    if (!allowedCountries || allowedCountries.length === 0) {
      return countryOptions
    }
    return countryOptions.filter(option => allowedCountries.includes(option.id))
  }, [allowedCountries])

  const handleCountryChange = (name, value) => {
    setState(name, value)
    if (value !== 'UnitedStates') {
      setState('state', null)
    }
  }

  return (
    <Grid container spacing={2}>
      {filteredCountryOptions.length > 1 && (
        <Grid item xs={12}>
          <JobTextField
            required
            label='Country'
            name='country'
            value={values.country}
            options={filteredCountryOptions}
            setState={handleCountryChange}
            showError={showError}
            setJobAlertData={setJobAlertData}
          />
        </Grid>
      )}
      {values.country && (
        <>
          <Grid item xs={isUnitedStates ? 6 : 12}>
            <JobTextField
              required
              label='City'
              name='city'
              value={values.city}
              setState={setState}
              showError={showError}
              setJobAlertData={setJobAlertData}
            />
          </Grid>
          {isUnitedStates && (
            <Grid item xs={6}>
              <JobTextField
                required
                label='State'
                name='state'
                value={values.state}
                options={stateOptions}
                setState={setState}
                showError={showError}
                setJobAlertData={setJobAlertData}
              />
            </Grid>
          )}
        </>
      )}
      <Grid item xs={12}>
        <JobChipField
          label='Area'
          name='area'
          options={areaOptions}
          icons={AREA_ICONS}
          value={values.area}
          setState={setState}
        />
      </Grid>
    </Grid>
  )
}

export default LocationSection
